/** Stable joins shared by evidence projection, persistence, and truth maintenance. */

import { fnv1a64 } from './similarity'
import type { Verification } from './types'
import { canonicalUrl } from './url'

export const webEvidenceRecordId = (url: string): string => `ev_web_${fnv1a64(canonicalUrl(url))}`

export const corpusEvidenceRecordId = (docId: string): string => `ev_corpus_${fnv1a64(docId)}`

export const outcomeEvidenceRecordId = (nodeId: string, recordedAt: number): string =>
  `ev_outcome_${fnv1a64(`${nodeId}|${recordedAt}`)}`

export const evidenceBindingId = (
  nodeId: string,
  verification: Pick<Verification, 'opId' | 'checkedAt'>,
  recordId: string,
): string =>
  `bind_${fnv1a64(`${nodeId}|${verification.opId ?? verification.checkedAt}|${recordId}`)}`

/** One durable user-authored join per exact claim and structured artefact. */
export const manualEvidenceBindingId = (nodeId: string, recordId: string): string =>
  `bind_manual_${fnv1a64(`${nodeId}|${recordId}`)}`
